import { memo } from 'react'
import Field from './Field'
import InputFieldSkeleton from './InputFieldSkeleton'
import { CRRender } from '../../crRender'


const InputField = ({ isLoading, name, formHandler, isRequired = true, isDisabled = false, type = "text", className = "col-md-6", defaultValue, min, step }) => {
    const { formValues, handleFormValues } = formHandler
   
    return (
        <>
            <InputFieldSkeleton isRender={isLoading} className={className} />
            <CRRender isRender={!isLoading}>
                <Field
                    className={className}
                    label={name}
                    type={type}
                    defaultValue={defaultValue}
                    isRequired={isRequired}
                    disabled={isDisabled}
                    value={formValues[name]}
                    setValue={val => handleFormValues(name, val)}
                    min={min}
                    step={step} />
            </CRRender>
        </>
    )
}

export default memo(InputField)